import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import "./Toast.scss";

export const useToast = () => {
    const [toasts, setToasts] = useState([]);

    const addToast =  (message, type = "info", duration = 4000, mode = "dark", template = null) => {
        const id = Date.now();
        setToasts(prev => [...prev, { id, message, type, duration, mode, template }]);
    };

    const removeToast = (id) => {
        setToasts(prev => prev.filter(t => t.id !== id));
    };

    return { toasts, addToast, removeToast };
};

const icons = {
    success: "check_circle",
    error: "error",
    warning: "warning",
    info: "info",
};

const Toast = ({ id, message, type = "info", onClose, duration, mode = "dark", template = null }) => {
    useEffect(() => {
        const timer = setTimeout(() => onClose(id), duration);
        return () => clearTimeout(timer);
    }, [id]);

    return (
        template ?
            <div className={`Toast general`}>
                {template}
                <button className="toast-close" onClick={() => onClose(id)}>
                    <span className="icon" data-icon="close"></span>
                </button>
            </div>
            :

            <div className={`Toast ${type} ${mode}`}>
                <span className="icon toast-icon" data-icon={icons[type] ?? "notifications"}></span>
                <div className="toast-body">
                    {message && <span className="toast-message">{message}</span>}
                    {template && <div className="toast-template">{template}</div>}
                </div>
                <button className="toast-close" onClick={() => onClose(id)}>
                    <span className="icon" data-icon="close"></span>
                </button>
            </div>
    );
};

export const ToastContainer = ({ toasts, removeToast }) => {
    return ReactDOM.createPortal(
        <div className="ToastContainer">
            {toasts.map(toast => (
                <Toast
                    key={toast.id}
                    {...toast}
                    onClose={removeToast}
                    mode={toast.mode}
                    duration={toast.duration}
                />
            ))}
        </div>,
        document.body
    );
};

export default Toast;
